import { numberFormat, pathOr, datetimeFormat } from '../helpers/utils';

export const transformedMeta = (meta = {}) => {
	return {
		path: pathOr('', ['path'])(meta),
		from: pathOr(null, ['from'])(meta),
		perPage: pathOr(null, ['per_page'])(meta),
		to: pathOr(null, ['to'])(meta),
		total: numberFormat(pathOr(null, ['total'])(meta)),
		currentPage: pathOr(1, ['current_page'])(meta),
		lastPage: pathOr(0, ['last_page'])(meta),
	};
};


export const transformedAuditLog = (audit = {}) => {
	const id = pathOr(null, ['id'])(audit);
	const createAt = audit.created_at ? datetimeFormat(audit.created_at) : '-';
	const userName = pathOr('', ['user', 'email'])(audit);
	const firstName = pathOr('', ['user', 'first_name'])(audit);
	const lastName = pathOr('', ['user', 'last_name'])(audit);
	const event = pathOr(null, ['event'])(audit);
	const entityId = pathOr(null, ['model_id'])(audit);
	const entity = pathOr(null, ['model_type'])(audit);
	const ipAddress = pathOr(null, ['ip_address'])(audit);
	const userAgent = pathOr(null, ['user_agent'])(audit);
	const oldValues = pathOr([], ['old_values'])(audit);
	const newValues = pathOr([], ['new_values'])(audit);
	const fullName = `${firstName} ${lastName}`;
	const entities = `(${entityId}) ${entity}`;

	return {
		id,
		createAt,
		userName,
		fullName,
		event,
		entityId,
		entity,
		ipAddress,
		userAgent,
		entities,
		oldValues,
		newValues,
	};
};

export const transformedAuditLogList = (audits = []) => {
	return audits.map(transformedAuditLog);
};
